import { Snackbar } from "@material-ui/core";

import { useSelector, useDispatch } from "react-redux";

import { useEffect, useState } from "react";

import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ProductService from "../../services/ProductService";
import UtilsFormule from "../../utils/UtilsFormule";
import { useNavigate } from "react-router-dom";

const AddFamily = () => {
  const navigate = useNavigate();
  const [confirmFamilyModel, setConfirmFamilyModel] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [isCancel, setIsCancel] = useState(false);
  const [name, setName] = useState();
  const [sku, setSku] = useState();
  const [listSkus, setListSkus] = useState([]);

  const [desc, setDesc] = useState();

  const [type, setType] = useState(1);

  const [onConfirmAddFamily, setOnConfirmAddFamily] = useState(false);
  useEffect(() => {
    ProductService.getAllSkuFamily(getCurrentUserId(), 0).then((result) => {
      setListSkus(result.data["productSkuFamily"]);
    });
  }, []);

  useEffect(() => {
    if (
      setOnConfirmAddFamily === false &&
      confirmFamilyModel !== null &&
      isCancel === false
    ) {
      setOpenSuccessAlert(true);
      setSuccessAlertText("Ajouté avec succès");
    }
  }, [onConfirmAddFamily]);

  const onChangeNameHandler = (event) => {
    setName(event.target.value);
  };
  const onChangeReferenceHandler = (event) => {
    setSku(event.target.value);
  };

  const onChangeDescriptionHandler = (event) => {
    setDesc(event.target.value);
  };

  const onValidFamilyHandler = () => {
    if (name == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le nom est vide ! ");
    } else if (sku === undefined || sku === null || sku === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :la référence est vide ! ");
    } else {
      let exist = UtilsFormule.testSKUExist(sku, listSkus);
      if (exist) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :la référence existe déjà ! ");
      } else {
        if (sku.length !== 2) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :la référence doit être deux lettres ! ");
        } else {
          let pattern = UtilsFormule.testSKUPattern(sku);
          if (!pattern) {
            setOpenErrorAlert(true);
            setErrorAlertText(
              "Erreur :la référence doit contenir deux lettres majuscules ! "
            );
          }else{
            let familyModel = {
              familyName: name,
              description: desc,
              idUserCreation: getCurrentUserId(),
              type: type,
              sku: sku,
            };
            console.log("familyModel", familyModel);
        
            ProductService.addProductFamily(familyModel).then((result) => {
              console.log("result", result.data["success"]);
              if (result.data["success"]) {
                setOpenSuccessAlert(true);
                setSuccessAlertText("Enregistrement avec succées");
                setTimeout(() => {
                  navigate(`/families`);
                }, 2000);
              } else {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur :erreur serveur ");
              }
            });
          }
        }
      }
    }


    // else if (type === 2) {
    //   if (sku === undefined || sku === null || sku === "") {
    //     setOpenErrorAlert(true);
    //     setErrorAlertText("Erreur :la référence est vide ! ");
    //   } else {
    //     let exist = UtilsFormule.testSKUExist(sku, listSkus);
    //     if (exist) {
    //       setOpenErrorAlert(true);
    //       setErrorAlertText("Erreur :la référence existe déjà ! ");
    //     } else {
    //       if (sku.length !== 2) {
    //         setOpenErrorAlert(true);
    //         setErrorAlertText("Erreur :la référence doit être deux lettres ! ");
    //       } else {
    //         let pattern = UtilsFormule.testSKUPattern(sku);
    //         if (!pattern) {
    //           setOpenErrorAlert(true);
    //           setErrorAlertText(
    //             "Erreur :la référence doit contenir deux lettres majuscules ! "
    //           );
    //         }
    //       }
    //     }
    //   }
    // }
    
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const blocSKU = () => {
    // if (type === 2) {
    let skuPossible = UtilsFormule.generateSKU(name, listSkus);
    return (
      <div class="row">
        <div className="col-sm-12">
          <div className="form-group">
            <label htmlFor="inputName">Référence {skuPossible}</label>
            <input
              placeholder="Ajouter une référence"
              onChange={onChangeReferenceHandler}
              type="text"
              id="inputName"
              className="form-control"
            />
          </div>
        </div>
      </div>
    );
    // } else if (type === 1) {
    //   return <div class="row"></div>;
    // }
  };
  const onValueChange = (event) => {
    if (event.target.value === "1") {
      setType(1);
    } else if (event.target.value === "2") {
      setType(2);
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter Famille</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title">
                    {" "}
                    Ajouter une famille de produit
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputName">Libellé</label>
                        <input
                          placeholder="Ajouter libellé "
                          onChange={onChangeNameHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-sm-12">
                      <label htmlFor="inputDescription">Description</label>
                      <textarea
                        placeholder="Saisir..."
                        onChange={onChangeDescriptionHandler}
                        id="inputDescription"
                        className="form-control"
                        rows={2}
                        defaultValue={""}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div class="form-group  clearfix">
                      <div class="icheck-asbestos d-inline">
                        <input
                          id="produit"
                          type="radio"
                          name="produit"
                          value="1"
                          checked={type === 1}
                          onChange={onValueChange}
                        />
                        <label for="produit">Produit </label>{" "}
                      </div>

                      <div class="icheck-asbestos d-inline">
                        <input
                          id="service"
                          type="radio"
                          name="service"
                          value="2"
                          checked={type === 2}
                          onChange={onValueChange}
                        />

                        <label for="service"> Service</label>
                      </div>
                    </div>
                  </div>
                  {blocSKU()}
                </div>
                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidFamilyHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AddFamily;
